import React from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import BlogsTable from "./blogTable"

const BlogList = ({ user_type }) => {
  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Blogs"} breadcrumbItem={"Blogs"} />
          <BlogsTable user_type={user_type} />
        </Container>
      </div>
    </>
  )
}

export default BlogList
